<template>
  <div id="supportBag" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN BOLSA DE APOYO -->

        <b-modal id="modal-create-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              agregar bolsa de apoyo
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la bolsa de apoyo"
            />
            <div class="mt-3 px-1 col-12 d-flex">
              <multiselect
                v-model="selectedlb"
                selectLabel="Seleccionar"
                deselectLabel="Eliminar"
                placeholder="Asígnale una o varias Líneas de Negocio"
                label="name"
                track-by="item"
                :options="optionslb"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              ></multiselect>
            </div>

            <!-- VALORES POR PUNTO DE VENTA? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿La Bolsa de Apoyo tendrá un valor diferenciado por Punto de
                Venta?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="onlyPercent"
              :options="onlyPercentOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="onlyPercent == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las lineas de negocio con puntaje
                  diferenciado</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb2"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <!-- PUNTOS O PORCENTAJE? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿La Bolsa de Apoyo se calculara por puntaje en alguna Línea de
                Negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="score"
              :options="scoreOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="score == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las Línea de Negocio donde se calculara la Bolsa
                  de Apoyo con Puntaje</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb3"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <!-- SUMA LA PROPINA DE LOS PUNTOS DE VENTA? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿En la Bolsa de Apoyo el puntaje de cada Punto de Venta varía
                de acuerdo al total de propinas recaudado en toda la Línea de
                Negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="scorePd"
              :options="scorePdOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="scorePd == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las Líneas de Negocio donde se tendrá en cuenta el
                  total recaudado de sus Puntos de Venta</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb4"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <div style="display: flex" class="mt-4">
              <button
                :disabled="
                  nameLN === '' || !selectedlb[0] || onlyPercent == null
                "
                @click="nextStep1SB('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create-sb')"
              >
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN BOLSA DE APOYO -->

        <b-modal id="modal-create2-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1 mb-4"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de guardar está Bolsa de Apoyo?
            </h3>
            <p class="pt-2">
              <span class="text-uppercase font-weight-bold">{{ nameLN }}</span>
            </p>
            <p>Lineas de Negocio:</p>
            <div v-for="lineB in selectedlb" :key="lineB.item">
              {{ lineB.name }}
            </div>
            <div style="display: flex" class="pt-4">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1SB('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep1SB('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN LINEA DE NEGOCIO -- EXITOSO  -->

        <b-modal id="modal-create3-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-create3-sb')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.trace" id="modal-fail-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.trace.message[0] }}</p>
            <button
              class="mt-2 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail-sb')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Editar BOLSA DE apoyo
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la bolsa de apoyo"
            />
            <div class="mt-3 px-1 col-12 d-flex">
              <multiselect
                v-model="selectedlb"
                selectLabel="Seleccionar"
                deselectLabel="Eliminar"
                placeholder="Asígnale una o varias Líneas de Negocio"
                label="name"
                track-by="item"
                :options="optionslb"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              ></multiselect>
            </div>
            <!-- VALORES POR PUNTO DE VENTA? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿La Bolsa de Apoyo tendrá un valor diferenciado por Punto de
                Venta?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="onlyPercent"
              :options="onlyPercentOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="onlyPercent == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las lineas de negocio con puntaje
                  diferenciado</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb2"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <!-- PUNTOS O PORCENTAJE? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿La Bolsa de Apoyo se calculara por puntaje en alguna Línea de
                Negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="score"
              :options="scoreOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="score == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las Línea de Negocio donde se calculara la Bolsa
                  de Apoyo con Puntaje</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb3"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <!-- SUMA LA PROPINA DE LOS PUNTOS DE VENTA? -->
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿En la Bolsa de Apoyo el puntaje de cada Punto de Venta varía
                de acuerdo al total de propinas recaudado en toda la Línea de
                Negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="scorePd"
              :options="scorePdOptions"
            ></b-form-select>
            <div class="m-0 p-0 col-12" v-if="scorePd == false">
              <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
                <span style="text-align: left"
                  >Selecciona las Líneas de Negocio donde se tendrá en cuenta el
                  total recaudado de sus Puntos de Venta</span
                >
              </p>
              <div class="mt-3 px-1 col-12 d-flex">
                <multiselect
                  v-model="selectedlb4"
                  selectLabel="Seleccionar"
                  deselectLabel="Eliminar"
                  placeholder="Asígnale una o varias Líneas de Negocio"
                  label="name"
                  track-by="item"
                  :options="selectedlb"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag2"
                ></multiselect>
              </div>
            </div>
            <div style="display: flex" class="mt-4">
              <button
                :disabled="checkEdit"
                @click="nextStep2SB('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2SB('nextD')"
              >
                <img src="@/assets/images/icons/delete_trash_white.svg" />
                <span class="cta ml-2"> Borrar Bolsa de Apoyo</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit2-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1 mb-4"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-4 mb-4 font-weight-bold">
              ¿Estás seguro de modificar la Bolsa de Apoyo?
            </h3>
            <p class="mt-2">
              <span>
                <b>Bolsa de Apoyo:</b>
                {{ nameLN }}
              </span>
            </p>
            <p class="">
              <span>
                <b>Valor Bolsa de Apoyo:</b>
                {{
                  onlyPercentOptions.find(
                    (elemento) => elemento.value == onlyPercent
                  ).text
                }}
              </span>
            </p>
            <p class="text-left">
              <span>
                <b>Calcula por:</b>
                {{
                  scoreOptions.find((elemento) => elemento.value == score).text
                }}
              </span>
            </p>
            <p class="">
              <span>
                <b>Tipo puntaje:</b>
                {{
                  scorePdOptions.find((elemento) => elemento.value == scorePd)
                    .text
                }}
              </span>
            </p>
            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2SB('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button
                @click="nextStep2SB('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit3-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-edit3-sb')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR LINEA DE NEGOCIO -->

        <b-modal id="modal-delete-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de eliminar la Bolsa de Apoyo?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="text-uppercase">{{ nameLN }}</span>
            </p>
            <div style="display: flex" class="mt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta">No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2SB('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar Bolsa de Apoyo</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 5 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-delete2-sb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-delete2-sb')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Bolsa de Apoyo -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Bolsa de Apoyo +" @nuevo="create"></AddCategory>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Bolsas de Apoyo</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar bolsa de apoyo"
                aria-label="Buscar bolsa de apoyo"
                autocomplete="off"
                class="form-control body_regular"
                v-model="datatable.filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editSupportBags(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="supportBags.data"
                :limit="10"
                @pagination-change-page="getFilterDp"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Multiselect from "vue-multiselect";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
export default {
  name: "LineBusiness",
  components: { Multiselect, Pagination, SelectSettings, AddCategory },
  data() {
    return {
      selectedlb: [],
      optionslb: [],
      selectedlb2: [],
      selectedlb3: [],
      selectedlb4: [],
      score: null,
      scoreOptions: [
        { value: null, text: "Selecciona una opción" },
        { value: false, text: "Sí, se calcurará por puntajes" },
        { value: true, text: "No, solo se calculará por porcentaje" },
      ],
      scorePd: null,
      scorePdOptions: [
        { value: null, text: "Selecciona una opción" },
        { value: false, text: "Sí, varia según el total de propinas" },
        { value: true, text: "No, siempre es un puntaje fijo " },
      ],
      onlyPercent: null,
      onlyPercentOptions: [
        { value: null, text: "Selecciona una opción" },
        { value: false, text: "Sí, tendra varios porcentajes" },
        { value: true, text: "No, sólo tendra un porcentaje" },
      ],
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      datatable: {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.loadRows();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "lineDeals",
      "supportBags",
      "supportBag",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actLineDeals",
      "actSupportBags",
      "actSupportBag",
      "actSaveSupportBag",
      "actUpdateSupportBag",
      "actDeleteSupportBag",
    ]),

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 500);
    },

    create() {
      this.nameLN = "";
      this.selectedlb = [];
      this.selectedlb2 = [];
      this.selectedlb3 = [];
      this.selectedlb4 = [];
      (this.onlyPercent = null), (this.score = null), (this.scorePd = null);
      this.$root.$emit("bv::show::modal", "modal-create-sb");
    },

    addTag(newTag) {
      const tag = {
        item: newTag + Math.floor(Math.random() * 10000000),
        name: newTag,
      };
      this.optionslb.push(tag);
      this.selectedlb.push(tag);
    },

    addTag2(newTag) {
      const tag = {
        item: newTag + Math.floor(Math.random() * 10000000),
        name: newTag,
      };
      this.selectedlb.push(tag);
      this.selectedlb2.push(tag);
    },

    nextStep1SB(x) {
      let array = [];
      this.selectedlb.forEach((x) => {
        var value = true;
        var value2 = false;
        var value3 = false;
        var lineBusiness = {};
        this.selectedlb2.forEach((y) => {
          if (x.item == y.item) {
            value = false;
            return;
          }
        });
        this.selectedlb3.forEach((y) => {
          if (x.item == y.item) {
            value2 = true;
            return;
          }
        });
        this.selectedlb4.forEach((y) => {
          if (x.item == y.item) {
            value3 = true;
            return;
          }
        });
        lineBusiness = {
          line_deals_id: x.item,
          only_a_point: value,
          score: value2,
          score_point_sale: value3,
        };
        array.push(lineBusiness);
      });

      let data = {
        name: this.nameLN,
        pro_line_deals: array,
      };

      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-sb");
          this.$root.$emit("bv::show::modal", "modal-create2-sb");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-sb");
          this.$root.$emit("bv::show::modal", "modal-create-sb");
          break;
        case "save":
          this.actSaveSupportBag(data).then(() => {
            if (this.error.data) {
              this.$root.$emit("bv::hide::modal", "modal-create2-sb");
              this.$root.$emit("bv::show::modal", "modal-fail-sb");
              return;
            } else {
              this.nameLN = "";
              this.selectedlb = [];
              (this.optionslb = []),
                this.$root.$emit("bv::hide::modal", "modal-create2-sb");
              this.$root.$emit("bv::show::modal", "modal-create3-sb");
              this.loadRows();
            }
          });
          break;
        default:
      }
    },
    loadRows() {
      this.optionslb = [];
      let filter = {
        data: "filter/",
      };
      this.actLineDeals(filter).then(() => {
        this.lineDeals.data.data.forEach((x) => {
          this.optionslb.push({
            item: x.id,
            name: x.name,
          });
        });
      });

      let page = {};
      this.getSupportBags(page);
    },
    editSupportBags(row) {
      this.actSupportBag(row.id).then(() => {
        this.selectedlb = [];
        this.selectedlb2 = [];
        this.selectedlb3 = [];
        this.selectedlb4 = [];
        this.nameLN = this.supportBag.name;
        this.optionslb.forEach((x) => {
          this.supportBag.pro_line_deals.forEach((y) => {
            if (x.item == y.pro_line_deal_id) {
              this.selectedlb.push(x);
            }
          });
        });
        this.selectedlb.forEach((x) => {
          this.supportBag.pro_line_deals.forEach((y) => {
            if (x.item == y.pro_line_deal_id && y.only_a_point == 0) {
              this.onlyPercent = false;
              this.selectedlb2.push(x);
            }
            if (x.item == y.pro_line_deal_id && y.score == 1) {
              this.score = false;
              this.selectedlb3.push(x);
            }
            if (x.item == y.pro_line_deal_id && y.score_point_sale == 1) {
              this.scorePd = false;
              this.selectedlb4.push(x);
            }
          });
        });
        this.$root.$emit("bv::show::modal", "modal-edit-sb");
      });
    },
    nextStep2SB(x) {
      let array = [];
      this.selectedlb.forEach((x) => {
        var value = true;
        var value2 = false;
        var value3 = false;
        var lineBusiness = {};
        this.selectedlb2.forEach((y) => {
          if (x.item == y.item) {
            value = false;
            return;
          }
        });
        this.selectedlb3.forEach((y) => {
          if (x.item == y.item) {
            value2 = true;
            return;
          }
        });
        this.selectedlb4.forEach((y) => {
          if (x.item == y.item) {
            value3 = true;
            return;
          }
        });
        lineBusiness = {
          line_deals_id: x.item,
          only_a_point: value,
          score: value2,
          score_point_sale: value3,
        };
        array.push(lineBusiness);
      });
      let data = {
        name: this.nameLN,
        pro_line_deals: array,
        id: this.supportBag.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-sb");
          this.$root.$emit("bv::show::modal", "modal-edit2-sb");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-sb");
          this.$root.$emit("bv::hide::modal", "modal-delete-sb");
          this.$root.$emit("bv::show::modal", "modal-edit-sb");
          break;
        case "edit":
          this.actUpdateSupportBag(data).then(() => {
            if (this.error.status) {
              this.nameLN = "";
              this.selectedlb = [];
              this.$root.$emit("bv::hide::modal", "modal-edit2-sb");
              this.$root.$emit("bv::show::modal", "modal-fail-sb");
              return;
            } else {
              this.nameLN = "";
              this.selectedlb = [];
              this.$root.$emit("bv::hide::modal", "modal-edit2-sb");
              this.$root.$emit("bv::show::modal", "modal-edit3-sb");
              this.loadRows();
            }
          });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-sb");
          this.$root.$emit("bv::show::modal", "modal-delete-sb");
          break;
        case "delete":
          this.actDeleteSupportBag(data.id)
            .then(() => {
              this.nameLN = "";
              this.selectedlb = [];
              this.$root.$emit("bv::hide::modal", "modal-delete-sb");
              this.$root.$emit("bv::show::modal", "modal-delete2-sb");
              this.loadRows();
            })
            .catch((response) => {
              this.$root.$emit("bv::hide::modal", "modal-delete-sb");
              this.$root.$emit("bv::show::modal", "modal-fail-sb");
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo conectar al servicio: error: " + response;
            });
          break;
        default:
      }
    },

    getFilterDp(page = 1) {
      this.datatable.rows = [];
      let data = {
        page: page,
      };
      this.getSupportBags(data);
    },
    getSupportBags(data) {
      this.datatable = {
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Bolsa de Apoyo",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Lineas de Negocio",
          field: "lineDeals",
          align: "left",
          headerClass: "theading",
          interpolate: true,
        },
      ];
      this.actSupportBags(data).then(() => {
        if (this.lineDeals.data) {
          this.supportBags.data.data.forEach((x) => {
            var array = x.pro_line_deals.split(",");
            let lineDeal = "";
            array.forEach((x) => {
              lineDeal += x + "<br>";
            });
            this.datatable.rows.push({
              id: x.id,
              name: x.name,
              lineDeals: lineDeal,
              only_percent: x.only_percent,
            });
          });
        }
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#supportBag {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    .theading {
      padding: 15px 15px;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }
    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>